export enum StateEnumLabel
{
    ACTIVE = "Actif",
    INACTIVE = "Inactif",
    ERROR = "Panne",
    OUTDATED = "MDP Périmé",
    DEFAULT = "Par défaut",
}